
  import { defineComponent } from 'vue'
  import { useMainStore } from '@/shared/store'
  import { useFavouriteStore } from '@/library/favourite/store'
  import { useShareStore } from '@/library/share/store'
  import { Album } from '@/shared/api'
  import ShareModal from '@/library/share/ShareModal.vue'
  import TrackList from '@/shared/components/track/TrackList.vue'
  import PlaylistModal from '@/library/playlist/PlaylistModal.vue'

  export default defineComponent({
    components: {
      TrackList,
      ShareModal,
      PlaylistModal,
    },
    props: {
      id: { type: String, required: true }
    },
    setup() {
      return {
        favouriteStore: useFavouriteStore(),
        shareStore: useShareStore(),
        mainStore: useMainStore()
      }
    },
    data() {
      return {
        album: null as null | Album,
        showShare: false,
        showPlaylist: false,
      }
    },
    computed: {
      isFavourite(): boolean {
        return !!this.favouriteStore.albums[this.id]
      },
    },
    async created() {
      this.album = await this.$api.getAlbumDetails(this.id)
    },
    methods: {
      playNow() {
        if (!this.album?.tracks) return
        return this.$store.dispatch('player/playNow', {
          tracks: this.album.tracks,
        })
      },
      shuffleNow() {
        if (!this.album?.tracks) return
        return this.$store.dispatch('player/shuffleNow', {
          tracks: this.album.tracks,
        })
      },
      setNextInQueue() {
        if (this.album) {
          return this.$store.dispatch('player/setNextInQueue', this.album.tracks)
        }
      },
      addToQueue() {
        if (this.album) {
          return this.$store.dispatch('player/addToQueue', this.album.tracks)
        }
      },
      toggleFavourite() {
        return this.favouriteStore.toggle('album', this.id)
      },
    }
  })
